import _ from 'lodash';

import { BillingAccount } from 'app/page/orders/model/billing-account';
import { ActiveOrder } from 'app/page/orders/model/active-order';
import { BillingAccountUtils } from 'app/page/orders/utils/billing-account-utils';

export class ReducerUtils {
    public static updateRecord<T>(items: Record<string, T>, itemId: string, newValues: Partial<T>): Record<string, T> {
        const updatedRecords = { ...items };

        updatedRecords[itemId] = _.merge({}, items[itemId], newValues);

        return updatedRecords;
    }

    public static updateBillingAccounts(
        billingAccounts: BillingAccount[],
        billingAccountId: string,
        newValues: Partial<BillingAccount>,
    ): BillingAccount[] {
        return billingAccounts.map((billingAccount) =>
            billingAccount.accountId === billingAccountId ? _.merge({}, billingAccount, newValues) : billingAccount,
        );
    }

    public static updateActiveOrder(
        billingAccounts: BillingAccount[],
        billingAccountId: string,
        orderId: string,
        newValues: Partial<ActiveOrder>,
    ): BillingAccount[] {
        const billingAccount: BillingAccount = BillingAccountUtils.getBillingAccount(billingAccounts, billingAccountId);

        return ReducerUtils.updateBillingAccounts(billingAccounts, billingAccountId, {
            activeOrders: ReducerUtils.updateRecord(billingAccount.activeOrders, orderId, newValues),
        });
    }

    public static updateAppointment(
        billingAccounts: BillingAccount[],
        billingAccountId: string,
        orderId: string,
        appointment: OrderTrackerBackend.Appointment,
    ): BillingAccount[] {
        return ReducerUtils.updateActiveOrder(billingAccounts, billingAccountId, orderId, {
            orderSummary: {
                ...BillingAccountUtils.getBillingAccount(billingAccounts, billingAccountId).activeOrders.orderSummary,
                appointment,
            },
        });
    }
}
